module.exports = "/assets/dist/img/instagram-logo.png?2197d78657b2e084c333880823419cc1";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/letter-jackets/site-footer/assets/instagram-logo.png
// module id = 1951
// module chunks = 30